import axios from 'axios';
import { Message } from '@arco-design/web-vue';
import {useMainStore} from './store.js';


// 请求拦截器
const interceptorDefault = {
	// 请求拦截
	request: (config) => {
		const mainStore = useMainStore();
		if (mainStore.userInfo) {
			config.headers.Authorization = mainStore.userInfo.token;
		}
		return config;
	},
	request_error: error => {
		return Promise.reject(error);
	},

	// 响应拦截
	response: response => {
		console.log("response", response);
		if (response.data.code != 1) {
			Message.error(response.data.msg);
			return Promise.reject(response.data.msg);
		}
		return Promise.resolve(response);
	},
	response_error: error => {
		if (error.response.status == 500) {
			Message.error(error.response.statusText);
		} else {
			Message.error(error.response.data.message);
		}

		return Promise.reject(error);
	}
};


let _CenterGmApi;

const CenterGmApi = () => {
	const mainStore = useMainStore();
	if (_CenterGmApi == null && mainStore.globalConfig.center_url.length > 0) {
		_CenterGmApi = axios.create({
			withCredentials: true, // 设置为true以允许跨域请求携带cookies但不许跨域
			baseURL: mainStore.globalConfig.center_url + "api.php",
			timeout: 5000,
		});
		// 设置拦截器
		_CenterGmApi.interceptors.request.use(interceptorDefault.request, interceptorDefault.request_error);
		_CenterGmApi.interceptors.response.use(interceptorDefault.response, interceptorDefault.response_error);
	}
	return _CenterGmApi;
}
const LocalRes = axios.create({
	withCredentials: true, // 设置为true以允许跨域请求携带cookies
	baseURL: "",
	timeout: 5000,
});

export {CenterGmApi, LocalRes};